exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.signature-pad {\n     position: relative;\n     display: block;\n     background-color: #ccc;\n}\n.signature-pad button {\n     float: right;\n     margin-right: 10px;\n     margin-bottom: 10px;\n}\n.signature-pad__body canvas {\n     position: relative;\n     margin: 10px 10px 10px;\n     background-color: #fefefe;\n}\n.signature-pad__body canvas:active, .signature-pad__body canvas:hover {\n     cursor: pointer;\n}\n", ""]);

// exports
